
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Mixpanel so we can track events
mixpanel.init("92144410d47e8d93a077925a551ceb2a", {
  debug: false,
  track_pageview: true,
  persistence: "localStorage",
  ignore_dnt: true,
});

console.log(`TalkTrees deployed: ${new Date(process.env.REACT_APP_BUILD_TIME || new Date()).toLocaleString()}`);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
